export default __webpack_public_path__ + "static/media/step-bg4.2177227f.png";